<template>
  <VSelect
    :items="bankAccountTypeList"
    item-text="name"
    item-value="id"
    v-bind="$attrs"
    v-on="$listeners"
    hide-details="auto"
  />
</template>

<script>
import { VSelect } from "vuetify/lib";
import { mapGetters } from "vuex";

export default {
  components: {
    VSelect,
  },
  computed: {
    ...mapGetters(["bankAccountTypeList"]),
  },
};
</script>
